import { prop } from 'ramda'

import { filterId } from './filterId'

type AppliedState = { [key: string]: Array<string> }

export const getFromApplied = (applied: AppliedState) => {
  const [result] = prop(filterId, applied) || []
  return !!result
}
